import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "reactstrap";
import SessionContext from "../SessionContext";
import ConfirmSuccess from "../core/ui/confirm-success";

export default function AdminForm() {
  const session = useContext(SessionContext);

  const [showSuccess, setShowSuccess] = useState(false);

  // in alphabetical order 
  const adminLinks = [
    {
      title: "Audit User Logs",
      description: "View users audit logs.",
      url: "/admin-user-logs"
    },
    {
      title: "Billing Codes",
      description: "Find, edit, or create billing codes.",
      url: "/admin-billing-codes"
    },
    {
      title: "Companies",
      description: "Find, edit, or create companies.",
      url: "/admin-companies"
    },
    {
      title: "Data Permissions",
      description: "Find, edit, or create data permissions.",
      url: "/admin-data-permissions"
    },
    {
      title: "Error Logs",
      description: "View system error logs.",
      url: "/admin-error-logs"
    },
    {
      title: "Invoice Categories",
      description: "Find, edit, or create invoice categories.",
      url: "/admin-invoice-categories"
    },
    {
      title: "Location Types and Icons",
      description: "Find, edit, or create location types and icons.",
      url: "/admin-location-types"
    },
    {
      title: "Royalty Cost",
      description: "Find, edit, or create royalty cost.",
      url: "/admin-royalty-pricing"
    },
    {
      title: "Users",
      description: "Find, edit, or create users.",
      url: "/admin-users"
    },
    {
      title: "Users Roles and Permissions",
      description: "Edit or create users roles.",
      url: "/admin-user-roles"
    },
    // keep this one as the last card
    {
      title: "Clear X-Filter Cache",
      description: "Clear all cached customer queries in X-Filter server.",
      action_label: "Clear Cache",
      action: clear_cache,
    },
  ];

  function clear_cache() {
    session.crossfilterStore.clear_cache().then(() => {
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
      }, 2500);
    });
  }

  return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
            <h1>Admin</h1>
        </div>
        <div className="admin-links">
          {
            adminLinks.map((card) => {
              return (
                <LinkCard
                  title={card.title}
                  description={card.description}
                  url={card.url || null}
                  key={card.title}
                  action={card.action || null}
                  action_label={card.action_label || null}
                />
              )
            })
          }
        </div>
        <ConfirmSuccess show={showSuccess} label="Cache Clear Sent to Backend" />
      </div>
  )
}


const LinkCard = ({title, description, url, action, action_label}) => {
  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <p className="card-text">{description}</p>
        {!action ?
          <Link to={url}>
            <Button className="new-button">Open</Button>
          </Link>
         : 
          <Button
            type="button"
            onClick={action} 
            className="new-button">
            {action_label}
          </Button>
        }
      </div>
    </div>
  );
};
